<main class="contenido-principal-nosotros">
    
    <section class="hero-nosotros">
        <div class="contenedor">
            <div class="imagen-hero-nosotros" role="img" aria-label="Imagen representativa de la empresa"></div>
            <div class="texto-hero-nosotros">
                <div class="circulo-azul-hero"></div>
                <h1 class="titulo-principal">¿Quiénes somos?</h1>
                <p class="parrafo-contenido">Somos una empresa especializada en <strong>brindar soluciones integrales para el abastecimiento del recurso hídrico</strong>, gestionando cada proyecto desde la consultoría inicial y la programación, hasta su ejecución y puesta en marcha; esto nos ha permitido construir una sólida trayectoria respaldada por más de <strong>30 años de experiencia técnica acumulada</strong>. Con el tiempo, hemos ampliado nuestro alcance en otras especializaciones complementarias como la <strong>electromecánica, automatización, mantenimiento industrial y más</strong>, manteniendo siempre un enfoque de <strong>calidad, seguridad e innovación.</strong></p>
                <p class="parrafo-contenido">Corporación Rehobot es un <strong>aliado estratégico multidisciplinario</strong> que ejecuta proyectos complejos con <strong>eficiencia y visión sostenible.</strong> Sus soluciones integrales contribuyen al desarrollo del país.</p>
            </div>    
        </div>
    </section>

    <section class="seccion-vision-mision">
        <div class="contenedor-vision-mision">
            <div class="contenido-vision-mision">
                <div class="vision">
                    <h2 class="titulo-pink-sunset">Visión</h2>
                    <p class="parrafo-contenido">Ser la <strong>empresa líder especializada en brindar soluciones integrales</strong> para el abastecimiento del recurso hídrico, constituyéndose como el aliado estratégico de los sectores productivos del país. Todo ello bajo un enfoque de <strong>calidad, responsabilidad y sostenibilidad</strong>, al servicio del desarrollo del país.</p>
                </div>
                <div class="separador-vision-mision">
                    <img src="assets/svg/separador.svg" alt="Separador decorativo" />
                </div>
                <div class="mision">
                    <h2 class="titulo-pink-sunset">Misión</h2>
                    <p class="parrafo-contenido">Contribuir al <strong>desarrollo del país</strong> a través de soluciones técnicas e integrales que optimicen el tiempo, los costos y la eficiencia en la ejecución de obras y servicios orientados al abastecimiento del recurso hídrico, mediante el uso de <strong>tecnología, ingeniería y procedimientos de calidad</strong>, bajo un enfoque de sostenibilidad, responsabilidad social y compromiso con los sectores productivos y poblacionales del país.</p>
                </div>
            </div>
        </div>
    </section>

    <section class="seccion-historia">
        <div class="contenedor">
            <div class="imagen-historia" role="img" aria-label="Historia de la empresa"></div>
            <div class="texto-historia">
                <h2 class="titulo-principal titulohistoria">Nuestra <span>historia.</span></h2>
                <p class="parrafo-contenido">Desde su fundación, <strong>Corporación Rehobot Contratistas Generales S.A.C.</strong> ha mantenido el compromiso de brindar <strong>soluciones integrales y sostenibles</strong>, especialmente en el <strong>abastecimiento del recurso hídrico</strong>, para atender las necesidades de los sectores productivos y poblacionales del país. La empresa se sustenta en un equipo de profesionales con más de <strong>30 años de experiencia en el rubro</strong>, lo que nos ha permitido ofrecer servicios <strong>especializados, personalizados y de alto valor técnico</strong>, ajustados a las exigencias de cada cliente y proyecto.</p>
                <p class="parrafo-contenido">A lo largo del tiempo, <strong>Corporación Rehobot</strong> ha fortalecido su capacidad operativa, ampliando su alcance a otros sectores estratégicos, y consolidándose como una empresa <strong>social y ambientalmente responsable</strong>, enfocada en la mejora continua y la <strong>generación de valor sostenible.</strong></p>
                <p class="parrafo-contenido">Este enfoque nos ha permitido posicionarnos en el mercado nacional como un <strong>aliado confiable y competitivo, comprometido</strong> con el desarrollo del país.</p>
            </div>
        </div>
    </section>

    <section class="seccion-valores">
        <div class="contenedor">
            <h2 class="titulo-principal">Nuestros valores <span>corporativos.</span></h2>
            <div class="grid-valores">
                <div class="linea-vertical"></div>
                <div class="linea-horizontal"></div>
                <div class="linea-horizontal_inferior"></div>
                
                <div class="valor" *ngFor="let valor of valores" [ngClass]="valor.claseExtra">
                    <h3 class="titulo-pink-sunset" [ngClass]="valor.claseExtra">{{ valor.titulo }}</h3>
                    <p>{{ valor.descripcion }}</p>
                </div>
            </div>
        </div>
    </section>

    <section class="seccion-ventajas">
        <div class="contenedor">
            <div class="contenido-ventajas">
                <div class="imagen-ventajas" role="img" aria-label="Ventajas competitivas"></div>
                <div class="texto-ventajas">
                    <div class="circulo-azul-ventajas circulo-azul-decorativo"></div>
                    <div class="Contenedor-ventajas contenedor-blanco">
                        <h2 class="titulo-principal">Ventajas <span>competitivas.</span></h2>
                        <ul class="lista-ventajas">
                            <li *ngFor="let ventaja of ventajas">
                                <span class="check"><img src="assets/svg/check.svg" alt="Check" /></span>
                                <span>{{ ventaja }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="seccion-final-nosotros">
        <div class="contenedor">
            <div class="imagen-final" role="img" aria-label="Imagen final corporativa"></div>
        </div>
    </section>
</main>